module.exports = __webpack_public_path__ + "static/media/sedex-hoje.edb2d9c3.svg";